<script setup lang="ts">
const dialogVisible = ref(false)
const props = defineProps<{
  contactInfo: any
}>()

const cancelButton = () => {
  dialogVisible.value = false
}
const showDialog = () => {
  dialogVisible.value = true
}
defineExpose({
  showDialog,
})
</script>
<template>
  <el-dialog v-model="dialogVisible" width="500px" top="30vh" center @close="cancelButton">
    <div class="flex flex-col items-center justify-center">
      <h2 class="main-title text-center text-themeColor2 text-2xl mb-6">联系我们</h2>

      <div class="qrcode-container text-center mb-4" v-if="contactInfo.wxQrCodeUrl">
        <img :src="contactInfo.wxQrCodeUrl" alt="微信二维码" class="w-[300px] h-[300px] mx-auto" />
        <p class="text-size14 mt-2 text-center">微信扫描二维码</p>
      </div>

      <div class="contact-info flex w-full justify-between mt-4 pb-[20px]">
        <div
          class="email-section flex-1 pr-2 border-r flex flex-col items-center justify-center"
          v-copy="contactInfo.email"
          v-if="contactInfo.email"
        >
          <h3 class="text-size16 mb-2 text-start">邮箱</h3>
          <p class="text-size14">
            {{ contactInfo.email }}
            <span class="text-themeColor2 cursor-pointer ml-2">复制</span>
          </p>
        </div>

        <div
          class="phone-section flex-1 pl-2 flex flex-col items-center justify-center"
          v-copy="contactInfo.telephone"
          v-if="contactInfo.telephone"
        >
          <h3 class="text-size16 mb-2 text-start">电话</h3>
          <p class="text-size14">
            {{ contactInfo.telephone }}
            <span class="text-themeColor2 cursor-pointer ml-2">复制</span>
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped>
.text-size14 {
  font-size: 14px;
}

.text-size16 {
  font-size: 16px;
}

.main-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
}
</style>
